<br />

<mat-card appearance="outlined">

    <mat-card-header>
        <mat-card-title><img src="/assets/img/prestalia.png" width="100px"></mat-card-title>
        <mat-card-subtitle><p class="subtitle">Esperance pour Haiti</p></mat-card-subtitle>
        <br />
        <mat-card-subtitle><p><small>PASSWORD RECOVERY</small></p></mat-card-subtitle>
        <mat-card-subtitle>
            <mat-error>{{ form.getError('backend') }}</mat-error>
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>

        <br />

        <form [formGroup]="form" (ngSubmit)="recover()">

            <div>
                <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="usr">
                    <mat-hint>Your registered email</mat-hint>
                    <mat-error *ngIf="form.get('usr')?.hasError('backend')">{{ form.get('usr')?.getError('backend') }}</mat-error>
                </mat-form-field>
            </div>
        
            <div>
                <mat-form-field>
                    <mat-label>Password</mat-label>
                    <input matInput formControlName="pwd" [type]="hide ? 'password' : 'text'">
                    <button mat-icon-button matSuffix (click)="hide = !hide">
                        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-hint>Type your new password here</mat-hint>
                    <mat-error *ngIf="form.get('pwd')?.hasError('backend')">{{ form.get('pwd')?.getError('backend') }}</mat-error>
                </mat-form-field>
            </div>
        
            <div>
                <mat-form-field>
                    <mat-label>PIN</mat-label>
                    <input matInput formControlName="pin" required placeholder="PIN" />
                    <mat-hint>Click GET PIN button below and we will send it to you by email</mat-hint>
                    <mat-error *ngIf="form.get('pin')?.hasError('backend')">{{ form.get('pin')?.getError('backend') }}</mat-error>
                </mat-form-field>
            </div>

            <br /><br />

            <button mat-flat-button color="accent"  type="button" (click)="pin()">GET PIN</button>
            <br /><br />
            <button mat-flat-button color="primary" type="submit">CHANGE PWD</button>

        </form>

    </mat-card-content>

    <br />

    <mat-card-actions>
        <button mat-button routerLink="/login">BACK TO LOGIN</button>
    </mat-card-actions>

</mat-card>